import * as React from 'react';

import { Grid } from 'semantic-ui-react';

export const MainGrid: React.SFC<{ children: React.ReactNode }> = ({ children }) => (
  <Grid columns="equal">
    <Grid.Column />
    <Grid.Column width={10}>
      {children}
    </Grid.Column>
    <Grid.Column />
  </Grid>
);


// WEBPACK FOOTER //
// ./src/components/main-grid.tsx